import { AddRounded, RefreshRounded, SearchRounded } from "@mui/icons-material";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Loader from "./Loader";

const DEFAULT_SORT = {
  pageNumber: 1,
  perPage: 10,
  searchText: "",
  isDescending: false,
  sortingOn: "",
};

interface ITableHeader {
  onPageChange: (obj: any) => void;
  title: string;
  onBtnAction?: () => void;
  loading: any;
  pageProps: any;
  onRefreshData?: (obj: any) => void;
  otherComponents?: React.ReactNode;
  headerComponents?: React.ReactNode;
  showAdd?: boolean;
  showSearch?: boolean;
  showRefresh?: boolean;
}

function TableHeader({
  otherComponents,
  headerComponents,
  title,
  onBtnAction,
  loading,
  onRefreshData,
  onPageChange,
  pageProps,
  showAdd = true,
  showSearch = true,
  showRefresh = true,
}: ITableHeader) {
  const [searchText, setSearchText] = useState("");
  const [changeSearch, setChangeSearch] = useState(false);

  useEffect(() => {
    const timerID = setTimeout(() => {
      if (changeSearch) {
        onPageChange({
          ...pageProps,
          searchText: searchText,
        });
      }
    }, 500);

    return () => clearTimeout(timerID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    setSearchText(value);
    setChangeSearch(true);
  };

  return (
    <Grid container className="flex justify-between flex-col  mb-4">
      <Grid md={3} sm={6} item className="flex gap-4 items-center">
        <Typography variant="h4">{title}</Typography>
      </Grid>

      <Grid item className="flex items-center justify-end w-full gap-2">
        {showSearch && (
          <TextField
            value={searchText}
            size="small"
            type="search"
            placeholder="Search"
            onChange={onSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchRounded />
                </InputAdornment>
              ),
            }}
          />
        )}
        {headerComponents && headerComponents}

        {showAdd && (
          <Tooltip title="Add">
            <Button variant="contained" onClick={onBtnAction}>
              <AddRounded />
            </Button>
          </Tooltip>
        )}
        {loading && <Loader size={24} />}
        {!loading && showRefresh && (
          <Tooltip title="Refresh">
            <IconButton
              onClick={
                onRefreshData ? () => onRefreshData(DEFAULT_SORT) : () => {}
              }
              color="primary"
            >
              <RefreshRounded />
            </IconButton>
          </Tooltip>
        )}
      </Grid>
      <Grid item>{otherComponents && otherComponents}</Grid>
    </Grid>
  );
}

export default TableHeader;
